export type VisionTagTheme =
  | 'default'
  | 'gradient'
  | 'grey'
  | 'orange'
  | 'gold'
  | 'white'
  | 'purple-pink'
  | 'promo'
  | 'blur'
  | 'none'

export interface VisionTagConfig {
    themes: VisionTagTheme[]
}

export const VisionTagConfig: VisionTagConfig = {
  themes: [
    'none',
    'default',
    'gradient',
    'grey',
    'orange',
    'gold',
    'white',
    'purple-pink',
    'promo',
    'blur'
  ],
}
